import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { version } from "../../../../package.json";
import styles from "./Versions.module.css";
import infoService from "../../../services/info.service";

const Versions = () => {
  const [apiVersion, setApiVersion] = useState<string>();

  useEffect(() => {
    const fetchApiVersion = async () => {
      const res = await infoService.getAPIVersion();
      setApiVersion(res ?? "");
    };

    fetchApiVersion();
  }, []);

  return (
    <div className={`${styles.versionsContainer} d-flex my-2 mx-3`}>
      <FormattedMessage id="GENERAL.VERSION" defaultMessage="Version" />
      :&nbsp;
      <FormattedMessage id="GENERAL.PORTAL" defaultMessage="Portal" />
      &nbsp;
      {`V${version}`}
      <div className={`${styles.divider} m-1`} />
      <FormattedMessage id="GENERAL.API" defaultMessage="API" />
      &nbsp;
      {`V${apiVersion}`}
    </div>
  );
};

export default Versions;
